import CRC32 from 'crc-32'

export class Calculater {
  operator = {
    '-': {
      priority: 0,
      calculate(a, b) {
        return a - b
      }
    },
    '+': {
      priority: 0,
      calculate(a, b) {
        return a + b
      }
    },
    '/': {
      priority: 1,
      calculate(a, b) {
        return a / b
      }
    },
    '*': {
      priority: 1,
      calculate(a, b) {
        return a * b
      }
    },
    'd': {
      priority: 2,
      calculate(a, b) {
        const { crc32, context } = this;
        const res = []
        let i = 0
        while (i++ < a) {
          res.push(crc32.next().value % b + 1)
        }
        // context.push(`[${res.join(',')}]`);
        res.forEach(r => context.push(r))
        const val = res.reduce((current, num) => {
          return current + num
        }, 0)
        return val
      }
    },
    'ccb<=': {
      priority: 3,
      calculate(a) {
        const { crc32, context } = this;
        const res = crc32.next().value % 100 + 1
        context.push(res)
        if (res <= 5) {
          context.push('Critical!!')
        }
        if (res <= a * 0.1) {
          context.push('Special!')
        }
        if (res >= 96) {
          context.push('Fumble!!')
        }
        return res <= a
      }
    },
    'ccb>=': {
      priority: 3,
      calculate(a) {
        const { crc32, context } = this;
        const res = crc32.next().value % 100 + 1
        context.push(res)
        return res >= a
      }
    },
    'res': {
      priority: 3,
      calculate(_a) {
        const { crc32, context } = this;
        const a =  50 + _a * 5
        const b = crc32.next().value % 100 + 1
        context.push(a + '%')
        context.push(b)
        return a >= b
      }
    },
    '<=': {
      priority: -1,
      calculate(a, b) {
        const { context } = this;
        // context.push(`<=${b}`)
        return a <= b
      }
    },
    '>=': {
      priority: -1,
      calculate(a, b) {
        const { context } = this
        // context.push(`>=${b}`)
        return a >= b
      }
    }
  }
  static isFormula(text) {
    return (/^([+\-*/()d]|\d+|<=|>=|ccb<=|ccb>=|res|\{\w+\})+$/).test(text.replace(/^(.+?)\s.+/, '$1'))
  }
  static toHalfString(text) {
    const regex = /[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g
    return text.replace(regex, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    }).replace(/[‐－―]/g, '-')
      .replace(/[～〜]/g, '~')
      .replace(/　/g, ' ')
  }
  static valid(text, vars, time, expectValue) {
    return this.exec(text, vars, time) === expectValue
  }
  constructor() {}
  exec(_text, vars, seed = Date.now()) {
    const text = Calculater.toHalfString(_text).toLowerCase()
    if (!Calculater.isFormula(text)) return null
    return this.calculate(this.parse(text), vars, seed)
  }
  crc32gen = function* crc32gen(seed) {
    let i = 0
    let val = seed
    while (i < i + 1) {
      i++
      val = Math.abs(CRC32.str(String(val)))
      yield val
    }
  }
  calculate(tokens, vars = {}, seed) {
    const { operator, crc32gen } = this
    const stack = []
    const context = [];
    const crc32 = crc32gen(seed);
    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i]
      if (operator[token]) {
        let tmp = operator[token].calculate.apply({ crc32, context }, stack.splice(-2))
        stack.push(tmp)
      } else {
        let value = token
        let varsKey = token.replace(/\{(\w+)\}/, '$1')
        if (/[0-9]/.test(token)) {
          value = parseInt(token, 10)
        } else if (vars[varsKey] !== undefined) {
          value = vars[varsKey]
        } else if (vars[varsKey.toUpperCase()] !== undefined) {
          value = vars[varsKey.toUpperCase()]
        }
        stack.push(value)
      }
    }
    // console.log(stack[0], context);
    return { result: stack[0], context };
  }
  parse(text) {
    const { operator } = this
    const tokens = text.replace(/^(([+\-*/()d]|\d+|<=|>=|ccb<=|ccb>=|res|\{\w+\})+).*$/, '$1').match(/[+\-*/()d]|\d+|<=|>=|ccb<=|ccb>=|res|\{\w+\}/g)
    const stack = []
    const res = []

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i]
      const lastStack = stack[stack.length - 1]
      if (token === '(') {
        stack.push(token)
      }
      else if (token === ')') {
        const i = stack.indexOf('(')
        while (i > -1 && stack.length > i) {
          const t = stack.pop()
          if (t !== '(') {
            res.push(t)
          }
        }
      }
      else if (operator[token]) {
        if (lastStack && operator[lastStack]) {
          let a = operator[lastStack].priority
          let b = operator[token].priority
          if (a >= b) {
            while (stack.length > 0) {
              const t = stack.pop()
              if (!operator[t]) {
                stack.push(t)
                break
              }
              res.push(t)
            }
          }
        }
        stack.push(token)
      }
      else {
        res.push(token)
      }
    }
    while (stack.length > 0) {
      res.push(stack.pop())
    }
    // console.log(res, stack);
    return res
  }
}

export default new Calculater()